import React from "react";
import Shimmer from "react-shimmer-effect";

const ShimmerComponent = ({ height = 30, width = "100%" }) => {
  return (
    <Shimmer>
      <div
        style={{
          width: width,
          height: height,
        }}
      ></div>
    </Shimmer>
  );
};

export { ShimmerComponent };
